import {
  Button,
  Card,
  CardHeader,
  CardBody,
  Dropdown,
  DropdownBody,
  DropdownButton,
  DropdownItem,
} from "@components";
import { ThreeDotsVertical } from "react-bootstrap-icons";
import { useMerchant } from "@auth";

const TemplateGrid = ({ data, actions, rowActions }) => {
  const { hasPermission } = useMerchant();

  return (
    <div className="flex-1 flex flex-col h-full overflow-auto">
      <div className="flex-none flex px-4 py-3 gap-2 w-full border-b border-zinc-200 h-16 items-center">
        <div className="ml-auto flex gap-2">
          {actions &&
            actions
              .filter((x) => !x.permission || hasPermission(x.permission))
              .map((x, i) => (
                <Button key={i} onClick={x.onClick} color={x.color}>
                  {x.label}
                </Button>
              ))}
        </div>
      </div>
      <div className="p-5 h-full flex flex-wrap bg-zinc-50 gap-5 content-start overflow-auto">
        {data &&
          data.map((x, i) => (
            <Card key={i}>
              <CardHeader>
                <p>{x.name}</p>
                {rowActions && (
                  <Dropdown className="ml-auto">
                    <DropdownButton>
                      <ThreeDotsVertical
                        role="button"
                        className="shrink-0 ml-auto"
                      />
                    </DropdownButton>
                    <DropdownBody position="left">
                      {rowActions
                        .filter(
                          (y) =>
                            (!y.show || y.show(x)) &&
                            (!y.permission || hasPermission(y.permission)),
                        )
                        .map((z, j) => (
                          <DropdownItem
                            closeOnComplete
                            key={j}
                            onClick={() => z.onClick(x)}
                          >
                            {z.label}
                          </DropdownItem>
                        ))}
                    </DropdownBody>
                  </Dropdown>
                )}
              </CardHeader>
              <CardBody>
                <p className="font-semibold">{x.emailSubject}</p>
                <p className="text-sm">{x.emailBody}</p>
              </CardBody>
            </Card>
          ))}
      </div>
    </div>
  );
};

export default TemplateGrid;
